 export const skillsData = [
    'HTML',
    'CSS',
    'Javascript',
    "Bootstrap",
    "MongoDB",
    "ExpressJS",
     'React',
     "nodejs",
    "canva",
    "MaterialUI",
    "Git",
    "Picsart",
    "Markdown",
]

